<template>
  <div class="help-center-search-suggestions__component">
    <p class="help-center-search-suggestions__title">
      Suggested Articles
    </p>
    <HelpCenterSearchResults
      :results="searchSuggestions"
      @close="close"
    />
  </div>
</template>

<script setup>
import HelpCenterSearchResults from 'help-center/components/HelpCenterSearchResults'

const emit = defineEmits(['close'])

defineProps({
  searchSuggestions: {
    type: Array,
    required: true
  }
})

function close() {
  emit('close')
}
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-search-suggestions {
  &__component {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__title {
    @include help-center-font(12);
    color: var(--help-center-muted);
    text-transform: uppercase;
  }
}
</style>
